<template>
  <div>
    <van-sticky v-if="showNotice">
      <van-notice-bar
        left-icon="volume-o"
        text="尊敬的会员，元旦至春节期间（1月1日-2月16日）暂停预约深度护理服务，元宵节后恢复正常服务预约"
      />
    </van-sticky>

    <div class="page">
      <div class="page-title">慕思金管家服务</div>
      <div class="page-cont">
        慕思“金管家”服务是慕思健康睡眠股份有限公司按照当今现代企业先进的服务标准和服务流程而推出的服务品牌,拥有完善的服务质量管理及服务经营运作体系,保障了客户服务的质量和效率，确保为用户提供方便、快捷、可靠的五星级服务
      </div>
      <div class="page-form">
        <van-field
          v-model.trim="state.form.name"
          clearable
          label="称呼"
          placeholder="请输入名称"
        />
        <van-field
          v-model.trim="state.form.phone"
          clearable
          label="手机"
          placeholder="请输入手机号码"
          type="number"
          maxlength="11"
        />
        <van-field
          readonly
          clickable
          name="area"
          :value="state.areaValue"
          label="服务地区"
          placeholder="请选择服务地区"
          @click="state.showArea = true"
        />
        <van-field
          v-model.trim="state.form.address"
          clearable
          label="详细地址"
          placeholder="请输入详细地址"
        />
        <van-field
          readonly
          clickable
          name="area"
          :value="state.form.serviceName"
          label="服务类型"
          placeholder="请选择服务类型"
          @click="state.showServiceType = true"
        />
        <van-field
          readonly
          clickable
          name="area"
          :value="state.form.serviceTime"
          label="期望服务时间"
          placeholder="请选择期望服务时间"
          @click="state.showDate = true"
        />
      </div>
      <div class="page-sub">
        <van-button
          class="page-sub_btn"
          block
          type="info"
          @click="onSubmit"
          :loading="state.loading"
          loading-text="加载中..."
          >立即预约</van-button
        >
      </div>
      <div class="page-phone">
        客服热线：<a href="tel:400-777-0077">400-777-0077</a>
      </div>

      <!-- 弹窗 -->
      <van-popup v-model="state.showServiceType" position="bottom">
        <van-picker
          title="服务类型"
          show-toolbar
          :columns="state.serviceList"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </van-popup>

      <van-popup v-model="state.showArea" position="bottom">
        <van-cascader
          v-model="state.cascaderValue"
          title="请选择服务地区"
          :options="state.areaList"
          @close="state.showArea = false"
          @change="onChange"
          @finish="onConfirmArea"
        />
      </van-popup>

      <van-popup v-model="state.showDate" position="bottom">
        <!-- <van-datetime-picker
          title="选择服务日期"
          v-model="state.currentDate"
          type="date"
          :min-date="state.minDate"
          :columns-type="['year', 'month', 'day']"
          @cancel="state.showDate = false"
          @confirm="onConfirmDate"
        /> -->
        <van-calendar
          title="选择服务日期"
          :poppable="false"
          :min-date="state.minDate"
          :formatter="formatter"
          :show-confirm="false"
          @confirm="onConfirmDate"
          style="height: 80vh"
        />
      </van-popup>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, computed } from "vue";
import { Toast, Dialog } from "vant";
import { saveNoMeberHKJServiceInfo, datadictionaryList } from "@/api/common.js";
import dayjs from "dayjs";

import { useRoute } from "@/utils/router";

const route = useRoute();

const initForm = () => {
  return {
    serviceType: "", // 服务类型 基础数据下拉列表中的code
    serviceName: "", // 服务名称 基础数据下拉列表中名称
    name: "",
    phone: "",
    provinceId: "",
    province: "",
    cityId: "",
    city: "",
    districtId: "", //服务地区 区 必填
    district: "", //服务地区 区 必填
    address: "", // 服务地址 必填
    serviceTime: "",
    fromSource: 11, // 来源渠道：来源基础表 会员小程序 5 慕思DeRUCCI公众号 11 慕思酒店 12 必填
  };
};
const state = reactive({
  form: initForm(),
  areaValue: "",
  showServiceType: false, // 服务类型弹窗
  serviceList: [
    { text: "除尘/除螨服务", value: "SH3025" },
    { text: "拆装服务", value: "SH3026" },
    { text: "沙发护理服务", value: "SH3027" },
    { text: "其他服务", value: "SH3028" },
  ], // 服务类型列表
  showArea: false,
  areaList: [], // 地区列表
  loading: false,
  cascaderValue: "",
  showDate: false,
  minDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 5),
  currentDate: "",
});

const showNotice = computed(() => {
  const date = route.query.date || new Date();
  const year = dayjs(date).format("YYYY");
  const month = dayjs(date).format("MM");
  const days = dayjs(date).format("DD");

  console.log(year, month, days);

  //控制节假日不可选
  if (year == "2025" && month == "01") {
    return true;
  }
  if (year == "2025" && month == "02" && days >= 1 && days <= 16) {
    return true;
  }
  return false;
});

//
onMounted(() => {
  const fromSource = route.query.fromSource ?? "";
  if (fromSource) {
    state.form.fromSource = fromSource;
  }
  getAreaList({ module: "public", type: "province" });
});

const getAreaList = (params, obj) => {
  const { tabIndex = "", value, selectedOptions } = obj || {};
  datadictionaryList(params).then((res) => {
    if (res.code === 0) {
      const list = res.data.map((item) => {
        if (tabIndex) {
          return { ...item, text: item.content, value: item.code };
        }
        return { ...item, text: item.content, value: item.code, children: [] };
      });
      if (tabIndex === 0 || tabIndex === 1) {
        selectedOptions.forEach((item) => {
          if (item.code === value) {
            item.children = list;
          }
        });
      } else {
        if (list[0]?.code === "001") {
          list.shift();
        }
        state.areaList = list;
      }
    }
  });
};

const onConfirmDate = (value) => {
  state.form.serviceTime = dayjs(value).format("YYYY-MM-DD");
  state.showDate = false;
};

const formatter = (day) => {
  const year = dayjs(day.date).format("YYYY");
  const month = dayjs(day.date).format("MM");
  const days = dayjs(day.date).format("DD");

  // const today = dayjs().format("DD");
  // if (days >= today && days < Number(today) + 3) {
  //   day.type = "disabled";
  // }

  //控制节假日不可选
  if (year == 2025 && month == "01") {
    day.bottomInfo = "休";
    day.type = "disabled";
  }
  if (year == 2025 && month == "02") {
    if (days >= 1 && days <= 16) {
      day.bottomInfo = "休";
      day.type = "disabled";
    }
  }
  return day;
};

const onChange = (obj) => {
  const { tabIndex, selectedOptions } = obj;
  const params = { module: "public", type: "province" };
  if (tabIndex === 0) {
    params.type = "city";
    params.parent_id = selectedOptions[0].id;
  }

  if (tabIndex === 1) {
    params.type = "area";
    params.parent_id = selectedOptions[1].id;
  }
  if (tabIndex == 2) return;

  getAreaList(params, obj);
};

const onConfirmArea = (obj) => {
  const value = obj.selectedOptions;
  state.form.provinceId = value[0].code;
  state.form.province = value[0].content;
  state.form.cityId = value[1].code;
  state.form.city = value[1].content;
  state.form.districtId = value[2].code;
  state.form.district = value[2].content;
  state.showArea = false;
  state.areaValue = `${value[0].content} - ${value[1].content} - ${value[2].content}`;
};

const onConfirm = (value) => {
  state.form.serviceType = value.value;
  state.form.serviceName = value.text;
  state.showServiceType = false;
};

const onCancel = () => {
  state.showServiceType = false;
};

const onSubmit = () => {
  const verify = {
    name: "请填写姓名",
    phone: "请填写手机号",
    province: "请选择省份",
    city: "请选择城市",
    district: "请选择地区",
    address: "请填写详细地址",
    serviceName: "请选择服务类型",
    serviceTime: "请选择服务日期",
  };
  for (const key in verify) {
    if (!state.form[key]) {
      Toast.fail(verify[key]);
      return;
    }
  }

  state.loading = true;
  const addressDetail = `${state.form.province || ""}${state.form.city || ""}${
    state.form.district || ""
  }${state.form.address}`;
  const params = { ...state.form, address: addressDetail };
  saveNoMeberHKJServiceInfo(params)
    .then((res) => {
      if (res.code === 0) {
        state.areaValue = "";
        state.form = initForm();
        Dialog({
          message:
            "预约成功，工作人员会在2个工作日内与您联系，请留意接听，谢谢！",
        });
      } else {
        Toast.fail(res.msg);
      }
    })
    .finally(() => {
      state.loading = false;
    });
};
</script>

<style lang="scss" scoped>
:deep(.page-form) {
  .van-cell {
    background: transparent;
    background: rgba(107, 107, 107, 0.5);
    border-radius: 4px;
    margin-bottom: 14px;

    &::after {
      display: none;
    }
  }

  .van-field__label {
    color: #edcf92;
    font-size: 14px;
  }

  .van-field__control {
    color: #edcf92;
    text-align: right;
  }

  .van-field__label {
    width: 90px;
  }
}

.page {
  background: #111111
    url(https://derucci-app-obs.iderucci.com/upload/20221207/24dc6fab426c96743ff1d911f094a159.png)
    top center no-repeat;
  background-size: 100% auto;
  padding: 0 16px;
  min-height: 100vh;

  &-phone {
    padding-top: 32px;
    padding-bottom: 50px;
    text-align: center;
    color: #d3a76d;
    font-size: 14px;

    a {
      color: #d3a76d;
    }
  }

  &-sub {
    margin-top: 59px;

    &_btn {
      width: 165px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #d3a76d;
      border-radius: 100px;
      background: transparent;
      color: #d3a76d;
      margin: 0 auto;
    }
  }

  &-form {
    margin-top: 33px;
    width: 345px;
    // height: 316px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 10px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 26px 15px;
  }

  &-title {
    padding-top: 51px;
    font-weight: 400;
    font-size: 40px;
    line-height: 56px;
    text-align: center;
    color: #ffffff;
    opacity: 0.8;
    margin-bottom: 10px;
  }

  &-cont {
    font-family: "PingFang SC";
    font-style: normal;
    height: 116px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;

    opacity: 0.6;
  }
}
</style>
